import React from 'react'
import PropTypes from 'prop-types'
import { InfoSection } from 'ui/acro'

const CenteredInfoSection = ({ headline, body, children, ...rest }) => (
  <InfoSection
    headline={headline}
    body={body}
    maxWidth='900px'
    alignSelf='center'
    align='center'
    px={['15px', null, '0px']}
    center
    {...rest}
  >
    {children}
  </InfoSection>
)

CenteredInfoSection.propTypes = {
  headline: PropTypes.string,
  body: PropTypes.string,
  children: PropTypes.node
}

export default CenteredInfoSection
